import PropTypes from "prop-types"

// material-ui
import { useTheme } from "@mui/material/styles"
import {
  AppBar,
  IconButton,
  Toolbar,
  useMediaQuery,
  SvgIcon,
} from "@mui/material"
import { BackArrow } from "assets/images/icons"
// project import
import AppBarStyled from "./AppBarStyled"
import HeaderContent from "./HeaderContent"

// assets
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons"
import zIndex from "@mui/material/styles/zIndex"

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = ({ open, handleDrawerToggle }) => {
  const theme = useTheme()
  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"))
  // common header
  const mainHeader = (
    <Toolbar>
      <SvgIcon
        onClick={handleDrawerToggle}
        sx={{ ml: { xs: 0, lg: -2 }, mr: 1, cursor: "pointer" }}
      >
        <BackArrow aria-label="open drawer" />
      </SvgIcon>

      <HeaderContent />
    </Toolbar>
  )

  // app-bar params
  const appBar = {
    color: "inherit",
    position: "relative",
    elevation: 0,
    height: "100%",
    sx: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      // boxShadow: theme.customShadows.z1
      gridColumn: open ? "2 / 13" : "1  /13",
      gridRow: "1",
      justifyContent: "center",
      zIndex: 20,
    },
  }
  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  )
}

Header.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
}

export default Header
